var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "arrow_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M422.24 339.84l.8.8L608 512 423.36 683.2a45.92 45.92 0 00-3.04 64 45.76 45.76 0 0064 3.2l.8-.8L705.6 546.4a46.08 46.08 0 00.96-66.4v-.8L485.6 273.6a45.76 45.76 0 00-64 66.24zM512 32a479.04 479.04 0 01339.36 140.48 481.12 481.12 0 01102.88 152.64 480 480 0 01-102.72 526.24 481.12 481.12 0 01-152.64 102.88 480 480 0 01-526.24-102.72A481.12 481.12 0 0169.76 698.88a480 480 0 01102.72-526.24A481.12 481.12 0 01325.12 69.76 475.68 475.68 0 01512 32zm0 883.2a401.92 401.92 0 10-156.96-32 402.24 402.24 0 00156.96 32z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.64526a0c4dc72eb20ae4d28d68ea90c8.svg";
export { ForwardRef as ReactComponent };